import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const recordShareLinkPrintEvent = api(async function recordShareLinkPrintEvent({ scheduleId, regimeId }) {
    return mutate(
        gql`
            mutation RecordShareLinkPrintEvent($scheduleId: String!, $regimeId: String) {
                recordShareLinkPrintEvent(scheduleId: $scheduleId, regimeId: $regimeId)
            }
        `,
        { scheduleId, regimeId },
        { returns: "recordShareLinkPrintEvent" }
    )
})
